import _ from 'lodash';
import { createActionHelpers } from 'vuex-loading';

/* Mutations */
export const UPDATE_ERROR = 'UPDATE_ERROR';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const UPDATE_LOADING = 'UPDATE_LOADING';
export const UPDATE_FORM = 'UPDATE_FORM';
export const UPDATE_TABLE_CTX = 'UPDATE_TABLE_CTX';
export const UPDATE_SEARCHED_OPERATIONS = 'UPDATE_SEARCHED_OPERATIONS';
export const UPDATE_SEARCHING_COLABORATORS = 'UPDATE_SEARCHING_COLABORATORS';
export const UPDATE_SEARCHED_COLABORATORS = 'UPDATE_SEARCHED_COLABORATORS';
/* Actions */
export const searchOperationAction = 'searchOperationAction';
export const searchColaboratorNameAction = 'searchColaboratorNameAction';
export const searchByFilterAction = 'searchByFilterAction';
export const cleanErrorAction = 'cleanErrorAction';
const { startLoading, endLoading } = createActionHelpers({
  moduleName: 'loading',
});

const initState = {
  error: '',
  loading: false,
  formModel: {
    filtro: '',
  },
  tableCtx: {
    currentPage: 1,
    perPage: 10,
    filter: '',
    sortBy: '',
    sortDesc: false,
  },
  searchedOperations: [],
  searchedColaborators: [],
  searchingColaborators: false,
};

export default {
  namespaced: true,
  state: Object.assign({}, initState),
  mutations: {
    [UPDATE_ERROR](state, error) {
      state.error = error;
    },
    [CLEAR_MODULE](state) {
      Object.assign(state, initState);
    },
    [UPDATE_LOADING](state, loading) {
      state.loading = loading;
    },
    [UPDATE_FORM](state, model) {
      state.formModel.nombre = model.nombre;
      state.formModel.estado = model.estado;
      state.formModel.colaborador = model.colaborador;
      state.formModel.comercial = model.comercial;
      state.formModel.cliente = model.cliente;
      state.formModel.tipoCliente = model.tipoCliente;
      state.formModel.desde = model.desde;
      state.formModel.hasta = model.hasta;
      state.formModel.importeDesde = model.importeDesde;
      state.formModel.importeHasta = model.importeHasta;
    },
    [UPDATE_TABLE_CTX](state, model) {
      state.tableCtx = Object.assign({}, state.tableCtx, model);
    },
    [UPDATE_SEARCHED_OPERATIONS](state, operations) {
      state.searchedOperations = operations;
    },
    [UPDATE_SEARCHING_COLABORATORS](state, newValue) {
      state.searchingColaborators = newValue;
    },
    [UPDATE_SEARCHED_COLABORATORS](state, lista) {
      state.searchedColaborators = lista;
    },
  },
  actions: {
    [cleanErrorAction]({ commit }) {
      commit(UPDATE_ERROR, '');
    },
    [searchOperationAction]({ commit, dispatch }, payload) {
      startLoading(dispatch, 'buscar operacion');
      commit(UPDATE_FORM, payload);
      commit(UPDATE_LOADING, true);
      commit(UPDATE_ERROR, '');
      const fetchConfig = {};
      _.forOwn(payload, (value, key) => {
        if (value !== '') {
          if (key === 'nombre') {
            fetchConfig.title = {
              modelName: 'title',
              operator: 'CONTAINS',
              value,
              path: 'title',
            };
          } else if (key === 'estado') {
            fetchConfig.state = {
              modelName: 'state',
              operator: '=',
              value,
              path: 'state.uuid',
            };
          } else if (key === 'colaborador') {
            fetchConfig.datesAssigments = {
              // NO model name as colaborator name is not in the entity. No local search
              operator: 'CONTAINS',
              value,
              path: 'dates_assigments.colaborador.title',
            };
          } else if (key === 'comercial') {
            fetchConfig.comercial = {
              // NO model name as colaborator name is not in the entity. No local search
              operator: '=',
              value,
              path: 'dates_assigments.comercial.uuid',
            };
          } else if (key === 'tipoOperacion') {
            fetchConfig.product = {
              operator: '=',
              value,
              path: 'product.uuid',
            };
          } else if (key === 'desde') {
            const date = new Date(payload.desde);
            const timestamp = date.getTime() / 1000;
            fetchConfig.created = {
              operator: '>',
              value: timestamp,
              path: 'product.uuid',
            };
          } else if (key === 'hasta') {
            const dateHasta = new Date(payload.hasta);
            const timestampHasta = dateHasta.getTime() / 1000;
            fetchConfig.created = {
              operator: '>',
              value: timestampHasta,
              path: 'product.uuid',
            };
          } else if (key === 'importeDesde') {
            fetchConfig.importeDesde = {
              modelName: 'nexumImporte',
              operator: '>=',
              value,
              path: 'importe_ofrecido',
            };
          } else if (key === 'importeHasta') {
            fetchConfig.importeDesde = {
              modelName: 'nexumImporte',
              operator: '<=',
              value,
              path: 'importe_ofrecido',
            };
          }
        }
      });
      dispatch('operation_model/fetchAction', fetchConfig, { root: true })
        .then((res) => {
          const { entities } = res;
          if (Array.isArray(entities) && entities.length > 0) {
            commit(UPDATE_SEARCHED_OPERATIONS, entities.map(e => e.id));
          } else {
            commit(UPDATE_SEARCHED_OPERATIONS, []);
          }
          endLoading(dispatch, 'buscar operacion');
          commit(UPDATE_LOADING, false);
        })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar operacion');
        });
    },
    [searchColaboratorNameAction]({ commit, dispatch }, name) {
      commit(UPDATE_SEARCHING_COLABORATORS, true);
      commit(UPDATE_SEARCHED_COLABORATORS, []);
      return dispatch('collaborator_model/fetchAction', {
        nombre: {
          modelName: 'title',
          operator: 'CONTAINS',
          value: name,
          path: 'title',
        },
      }, { root: true })
        .then((lista) => {
          const { entities } = lista;
          commit(UPDATE_SEARCHING_COLABORATORS, false);
          commit(UPDATE_SEARCHED_COLABORATORS, entities);
        })
        .catch(() => {
          commit(UPDATE_SEARCHING_COLABORATORS, false);
        });
    },
    [searchByFilterAction]({ commit, dispatch, rootGetters }, payload) {
      startLoading(dispatch, 'buscar operacion');
      let states = rootGetters['taxonomy/getTaxonomy']('status');
      let config = {};
      switch (payload) {
        case 'Operaciones aprobadas':
          states = states.filter(e => e.name === 'Aprobada');
          config = { state: {
            operator: '=',
            value: states[0].uuid,
            path: 'state.uuid',
          },
          };
          break;
        case 'Operaciones en curso':
          states = states.filter(e => e.name !== 'Denegada' && e.name !== 'Cancelada' && e.name !== 'Vencida');
          states = states.map(e => e.uuid);
          config = {
            state: {
              operator: 'IN',
              value: states,
              path: 'state.uuid',
            },
          };
          break;
        case 'Operaciones denegadas':
          states = states.filter(e => e.name === 'Denegada');
          config = { state: {
            operator: '=',
            value: states[0].uuid,
            path: 'state.uuid',
          },
          };
          break;
        default:
          break;
      }
      dispatch('operation_model/fetchAction', config, { root: true }).then((res) => {
        const { entities } = res;
        if (Array.isArray(entities) && entities.length > 0) {
          commit(UPDATE_SEARCHED_OPERATIONS, entities.map(e => e.id));
        } else {
          commit(UPDATE_SEARCHED_OPERATIONS, []);
        }
        commit(UPDATE_LOADING, false);
        endLoading(dispatch, 'buscar operacion');
      })
        .catch((error) => {
          dispatch('updateErrorOverlay', error, { root: true });
          endLoading(dispatch, 'buscar operacion');
        });
    },
  },
  getters: {
    isLoading: state => state.loading,
    error: state => state.error,
    searchedOperations: state => state.searchedOperations,
    existError: state => state.error !== '',
    searchedColaborators: state => state.searchedColaborators,
    isSearchingColaborators: state => state.searchingColaborators,
  },
};



// WEBPACK FOOTER //
// ./src/features/menu-operaciones/store.js